// extracted by mini-css-extract-plugin
export var heroImage = "_kd-1";
export var modal = "_kd-0";